export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const size = favicon.sizes[[0]];
    favicon.href = `/botz/favicon_${size}.png`;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const size = favicon.sizes[[0]];
        favicon.href = `/botz/favicon_${size}.png`;
      });
    }
  });
};
